// extracted by mini-css-extract-plugin
module.exports = {"main":"RouterComponent_main__2GjjQ"};